/** The Switch element: one value matched against cases, with a default list. */
import { MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { WorkflowStepType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Runs the first case whose `equals` matches the value, otherwise `default`. */
export const SWITCH_ELEMENT: WorkflowElement = {
    type: WorkflowStepType.Switch,
    family: WorkflowFamily.Flow,
    sideEffect: WorkflowSideEffect.None,
    title: 'Switch',
    icon: 'fa-arrows-split-up-and-left',
    fields: [
        {
            bind: 'value',
            required: true,
            renderer: WorkflowFieldRenderer.Binding,
            metadata: {
                displayName: 'Value',
                type: MetadataEntityFieldType.Custom,
            },
        },
    ],
    outputs: [],
    branches: [
        { prop: 'cases', title: 'Cases' },
        { prop: 'default', title: 'Otherwise' },
    ],
};
